<template>
  <TemplateDefault>
    <template #breadcrumbHeader>
      <DocumentsBreadcrumb />
    </template>

    <template #pageHeading>
      <PageHeadingDefault>
        お役立ち資料
      </PageHeadingDefault>
    </template>

    <template #main>
      <DocumentsMain />
    </template>

    <template #breadcrumbFooter>
      <DocumentsBreadcrumb />
    </template>
  </TemplateDefault>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import DocumentsMain from './Main.vue'
import DocumentsBreadcrumb from './Breadcrumb.vue'
import PageHeadingDefault from '@/components/_core/PageHeadingDefault.vue'

export default defineComponent({
  name: 'DocumentsApp',

  components: {
    DocumentsMain,
    DocumentsBreadcrumb,
    PageHeadingDefault,
  },
})
</script>

